import { voices, stats } from "@/mocks/chigua";

export default function About() {
  return (
    <section id="about" className="border-y border-background-200 bg-background-100/60">
      <div className="container-page py-12 md:py-16">
        <div className="grid grid-cols-1 items-center gap-8 lg:grid-cols-12 lg:gap-12">
          {/* brand story */}
          <div className="lg:col-span-6">
            <p className="flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.25em] text-accent-700">
              <i className="ri-heart-line"></i>
              ABOUT US
            </p>
            <h2 className="section-title mt-3">关于吃瓜日报</h2>
            <p className="mt-4 text-[15px] leading-relaxed text-foreground-600">
              吃瓜日报是一档专注娱乐与社会热议话题的内容盘点栏目。我们相信，热闹背后值得被认真读懂——所以不只搬运热搜，更尝试把「为什么会火」「大家为什么都在讨论」讲清楚。
            </p>
            <div className="mt-5 space-y-3 text-sm text-foreground-700">
              <p className="flex items-start gap-2.5">
                <i className="mt-0.5 ri-compass-3-line text-accent-600"></i>
                <span><b className="text-foreground-900">内容定位：</b>热榜排行 + 爆款精选 + 专题盘点 + 必看快讯，覆盖娱乐、综艺、影视、音乐、社会热议、电竞等热门品类。</span>
              </p>
              <p className="flex items-start gap-2.5">
                <i className="mt-0.5 ri-shield-check-line text-accent-600"></i>
                <span><b className="text-foreground-900">内容原则：</b>多方信源交叉核对，观点标注边界，转述注明出处，理性吃瓜不传谣。</span>
              </p>
              <p className="flex items-start gap-2.5">
                <i className="mt-0.5 ri-lightbulb-line text-accent-600"></i>
                <span><b className="text-foreground-900">发展理念：</b>让碎片时间的每一次刷新都有收获，用有温度有观点的内容陪伴每一位读者的日常。</span>
              </p>
            </div>

            <div className="mt-7 grid grid-cols-2 gap-4 sm:grid-cols-4">
              {stats.map((s) => (
                <div key={s.label} className="rounded-xl border border-background-200 bg-background-50 p-4 text-center">
                  <p className="font-display text-2xl font-black text-primary-600">{s.value}</p>
                  <p className="mt-1 text-xs text-foreground-500">{s.label}</p>
                </div>
              ))}
            </div>
          </div>

          {/* voices / 口碑 */}
          <div className="lg:col-span-6">
            <div className="rounded-2xl border border-background-200 bg-background-100 p-5 md:p-7">
              <div className="flex items-center justify-between">
                <p className="flex items-center gap-2 text-sm font-bold text-foreground-900">
                  <i className="ri-chat-quote-line text-accent-600"></i>
                  读者口碑
                </p>
                <span className="flex items-center gap-1 text-accent-600">
                  {Array.from({ length: 5 }).map((_, i) => (
                    <i key={i} className="ri-star-fill text-sm"></i>
                  ))}
                </span>
              </div>
              <div className="mt-5 grid grid-cols-1 gap-3 sm:grid-cols-2">
                {voices.map((v) => (
                  <figure key={v.name} className="rounded-xl border border-background-200 bg-background-50 p-4">
                    <p className="text-sm leading-relaxed text-foreground-700">「{v.text}」</p>
                    <figcaption className="mt-3 flex items-center gap-2.5">
                      <span className="flex h-9 w-9 items-center justify-center rounded-full bg-accent-100 font-display font-bold text-accent-700">
                        {v.initials}
                      </span>
                      <span className="min-w-0">
                        <span className="block truncate text-sm font-semibold text-foreground-900">{v.name}</span>
                        <span className="block text-xs text-foreground-500">{v.role}</span>
                      </span>
                    </figcaption>
                  </figure>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}